import type { StorageAccountKey } from "@warrenio/api-spec/spec.oats.gen";

export const storageKeys: StorageAccountKey[] = [
    {
        description: "Storage account key",
        read_only: false,
        access_key: "2JPM1ELQ6TBR09RJDQ9J", // cspell:disable-line
        secret_key: "iyLpQxIDoEb55t99O4YTWusA5lXoFdJwNgGb1OA3",
        created_at: "2026-07-15T08:20:38.070+0000",
    },
    {
        read_only: true,
        access_key: "EGR1I8WG5F5Y7J20668X",
        secret_key: "BhtxTAZ4MtGBDjweQfS1bSrE77XLc3APWJr9jsXG",
        created_at: "2026-07-12T08:20:38.070+0000",
    },
];
